<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/18Ukoql/tc-custom/9781504074377.jpg?1726617311300" alt="This image is the cover for the book Jack Reacher, Mysterious Profiles"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Jack Reacher, Mysterious Profiles
      </h1>
      <p class="bookDescription body article font2">
        <b>The #1 <i>New York Times</i>–bestselling author reveals the story behind “one of this century’s most original, tantalizing pop-fiction heroes” (<i>The Washington Post</i>).</b><br/><br/>In this short piece, the creator of Jack Reacher shares the origins of the ex-military cop who now makes use of his skills in the civilian world—a place where he never feels quite at home. In addition, Lee Child reflects on writing and his own life story: the importance of character; making the transition from a television career to a literary career; how his famous character was almost named Franklin—and how he wound up being called Reacher instead. <br/><br/>“Jack Reacher is today’s James Bond, a thriller hero we can’t get enough of. I read every one as soon as it appears.” —Ken Follett, international-bestselling author of <i>The Pillars of the Earth</i><br/><br/>“Every Reacher novel delivers a jolt to the nervous system.” —<i>Kirkus Reviews</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lee Child
      </h2>
      
      <p class="authorDescription body article">Lee Child was born in 1954 in Coventry, England. His family soon moved to Birmingham, where he went to the same high school that J. R. R. Tolkien once attended. He received a formal English education, learning Latin, Greek, and Old English, before he attended law school in Sheffield. After working in the theater, he began an eighteen-year career with Granada Television in Manchester. After company-wide restructuring, he left, embarking on a fiction-writing career.<BR /><BR /> Jack Reacher, who has been featured in all of Child&rsquo;s novels, made his first appearance in 1997 in <I>Killing Floor</I>, which was an immediate success, winning both the Anthony and Barry Awards for best first novel of the year. The series has increased in popularity each year, with foreign rights selling widely around the world, while making regular appearances on major bestseller lists everywhere. <I>One Shot</I> (2005), was made into the movie <I>Jack Reacher</I>, starring Tom Cruise.<BR /><BR /> The James Bond&ndash;like author drives a supercharged Jaguar and divides his time between the south of France and Manhattan, where he has become an enthusiastic fan of the New York Yankees. He is married and has a daughter.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3901247a